

























import { serialize } from "class-transformer";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import BeforeUnload from "../../mixins/BeforeUnload";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import { LineItems } from "../../models/ProjectProposal";
import FormDirtyOnLeavePage from "../private/forms/FormDirtyOnLeavePage.vue";

@Component({
    beforeRouteLeave(this: ProjectProposalsLineItems, to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        this.isDirty ? (this.showModal = true) : next();
    },
    components: {
        FormDirtyOnLeavePage
    }
})
export default class ProjectProposalsLineItems extends Mixins(ProjectProposalMixin, Utils, BeforeUnload) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;

    loading = true;
    showModal = false;
    private originalData = "";
    private isDirty = false;
    lineItems: LineItems | null = null;
    isValid: string[] = [];

    @Watch("lineItems", { deep: true })
    onRowsChange() {
        this.isDirty = !!this.originalData && this.originalData !== serialize(this.lineItems);
        this.setBeforeUnload();
    }

    async loadData() {
        this.loading = true;
        const [data, err] = await this.maltaModule.projectProposalApi.getProjectProposalLineItems(
            this.subjectId,
            this.applicationId
        );
        if (err) this.goHomeGenericError();
        else if (data) {
            this.originalData = serialize(data);
            this.lineItems = data;
        }
        this.loading = false;
    }

    async mounted() {
        await this.loadData();
    }

    backToHome(force = false) {
        if (force) {
            this.unsetBeforeUnload();
            this.originalData = serialize(this.lineItems);
        }
        this.isDirty = this.originalData !== serialize(this.lineItems);
        this.goHome();
    }

    async saveAndGoBack() {
        const quotationId = +this.$route.params.quotationId;
        const itemId = +this.$route.params.itemId;
        if (this.lineItems) {
            this.loading = true;
            this.isValid = this.lineItems.isValid;
            if (this.isValid.length === 0) {
                const [resp, err] = await this.maltaModule.projectProposalApi.setProjectProposalLineItems(
                    this.subjectId,
                    this.applicationId,
                    this.lineItems
                );
                if (err) this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                else {
                    this.unsetBeforeUnload();
                    this.originalData = serialize(resp);
                    this.lineItems = resp;
                    this.isDirty = false;
                    this.$emit("reload");
                    this.toast(this.i18n("saved-item").toString(), { type: "success" });
                    if (this.$route.name === "project-proposal-line-items-list") this.goHome(true);
                    else if (!isNaN(itemId) && itemId > 0 && !isNaN(quotationId) && quotationId < 0)
                        this.$router.replace({ name: "project-proposal-line-items-edit", replace: true });
                    else if ((!isNaN(itemId) && itemId < 0) || (!isNaN(quotationId) && quotationId < 0))
                        this.$router.replace({ name: "project-proposal-line-items-list", replace: true });
                }
            } else this.toast(this.i18n("form-not-valid").toString(), { type: "error" });
            this.loading = false;
        }
    }

    beforeDestroy() {
        this.unsetBeforeUnload();
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }
}
